<template>
	<div class="filter-wrapper" :class="this.highlight ? 'selected' : 'not-selected'"
		style="border:1px solid var(--grey-5);border-radius:5px;">
		<div style="" :title="this.title" :class="this.disabled ? '' : 'link'">

			<!-- välja kategori-knapp -->
			<div class="filter-button" style="padding:5px;" @click="this.togglePopover() ">
				<div class="flexcenter" style="height:26px;">

					<Icon :fileName="this.highlight ? 'w3_circle_close_white' : 'w3_circle_close_dark'" v-if="this.category"
						@click.stop="this.setCategory(null)" style="height:16px;width:16px;" />


					<b class="font-normal" :class="this.disabled ? 'disabled' : 'enabled'">{{ this.category ?
						this.categoryPathLabel(this.categoryPath) : 'Kategorier' }} </b>
				</div>
				<div class="flexcenter filter-button-label" style="flex-grow:1;">
					<div class="font-small" :class="this.disabled ? 'disabled' : 'enabled' " style="flex-grow:1;">{{ this.category
						? this.category.name
						: 'Välj&nbsp;kategori' }}</div>


					<Icon v-if="this.highlight" :fileName="this.popoverCategory ? 'w3_chevron_up_white' : 'w3_chevron_down_white'"
						style="width:12px;height:12px;margin-left:10px;" />

					<Icon v-if="!this.highlight && this.popoverCategory" fileName="w3_chevron_up_dark"
						style="width:12px;height:12px;margin-left:10px;" />

					<!-- om boxen är disabled/enabled -->
					<Icon v-if="!this.highlight && !this.popoverCategory"
						:fileName="this.disabled ? 'w3_chevron_down_light' : 'w3_chevron_down_dark'"
						style="width:12px;height:12px;margin-left:10px;" :link="!this.disabled" />
				</div>
			</div>

			<!-- kategori popover -->
			<div v-show="this.popoverCategory" @mouseleave="this.popoverCategory = false;"
				class="dropdown dropdown-w400 dropdown-h400 dropdown-p10 dropdown-shadow" style="background:var(--grey-3);">



				<!-- lista under-kategorier i vald kategori-->
				<div style="height:100%;">

					<div class="flexcenter" v-if="this.isFilterCategoryEmpty">

						<Icon v-if="this.category" fileName="w3_chevron_left_dark" style="width:10px;height:16px;margin-right:5px;"
							@click="selectCategory(this.categoryPopover.parent)" />

						<h3 @click="this.category && selectCategory(this.categoryPopover.parent)"> {{ this.categoryPopover?.name }}
						</h3>
						<b style="flex-grow:1;">&nbsp;</b>
						<img src="@/assets/button_close_dark.png" class="link" @click="this.popoverCategory = false;"
							style="height:20px;width:20px;margin-right:5px;" />
					</div>

					<div v-if="!this.isFilterCategoryEmpty">
						<h3>Kategori</h3>
					</div>

					<!-- fritextsökning input -->

					<div v-if="!this.category || !this.isFilterCategoryEmpty" class="form textField"
						:title="'filter: ' + this.filterCategory"
						style="height:30px;padding:0px;margin-top:5px;margin-bottom:10px;">
						<input type="text" placeholder="Sök kategori..." v-model="this.filterCategory" />
						<img src="@/assets/w3_button_close_light.png" v-if="!this.isFilterCategoryEmpty"
							@click="this.filterCategory = ''" style="height:20px;width:20px;margin-right:5px;" />
					</div>

					<!-- fritextsökning resultat -->
					<div v-if="!this.isFilterCategoryEmpty" style="height:calc(100% - 0px);padding-top:5px;padding-bottom:5px;">



						<!-- sökresultat -->
						<div style="overflow:scroll;max-height:calc(100% - 80px);">



							<div v-for="(category, index) in filteredCategoryList" :key="index"
								style="background:var(--grey-1);padding:5px;" @click="this.selectCategory(category.categoryId)">
								<b>{{ category.name }}</b><br />
								<span style="color:grey;margin-left:0px;font-size:85%;">{{ category.path }}</span>

							</div>
						</div>
					</div>

					<!-- lista kategori-träd utan sökning, dra av för höjden på sökfältet -->
					<div v-if="this.isFilterCategoryEmpty" style="overflow:scroll;margin-top:10px;"
						:style="this.category ? 'max-height:calc(100% - 50px);' : 'max-height:calc(100% - 100px);'"
						ref="categoryList">
						<!-- this.categoryPopover?.categoryList -->
						<div v-for="category in this.enabledCategoryList" :key="category.categoryId"
							:style="this.category && this.category.categoryId == category.categoryId ? 'background:var(--grey-5);' : 'background:var(--grey-1);'"
							style="margin-bottom:5px;" class="link categoryLabel">

							<!-- klickbar kategori, wrapper -->
							<div style="" ref="categoryListRef" :id="'category-' + category.categoryId">

								<div class="flexcenter" v-if="category.categoryList" style="align-items: stretch;">
									<div @click="this.setCategory(category); this.popoverCategory = false;" style="flex-grow:1;"> {{
										category.name }} {{ this.isCategoryEnabledLabel(category) }} </div>


									<div class="flexcenter link" style="padding-left:40px;background:var(--grey-5); "
										@click="this.setCategory(category);">
										<Icon fileName="w3_chevron_right_white"
											style="width:8px;height:12px;margin-right:5px;margin-left:10px;" />
									</div>

								</div>

								<!-- slutnoderna, de som inte har några underkategorier -->
								<div class="flexcenter" v-if="!category.categoryList"
									@click="this.setCategory(category); this.popoverCategory = false;">
									{{ category.name }} {{ this.isCategoryEnabledLabel(category) }}
									<b style="flex-grow:1;">&nbsp;</b>

									<!-- category.productList?.length -->
								</div>
							</div>

						</div>
					</div>
				</div>


				<div v-if="!this.category && false" style="overflow:scroll;max-height:calc(100% - 100px);">
					<div style="padding:5px;margin-bottom:10px;">
						<b>Lista huvud-kategorier</b>
					</div>
					<div v-for="category in this.categoryPopover.categoryList" :key="category.categoryId"
						style="background:var(--grey-1);padding:5px;margin-bottom:5px;" @click="this.setCategory(category)"
						class="link flexcenter">
						<div>{{ category.name }}</div>
						<b style="flex-grow:1;">&nbsp;</b>

						<Icon fileName="w3_chevron_right_dark" style="width:8px;height:12px;margin-right:5px;" />

					</div>
				</div>
			</div>
		</div>
	</div>


</template>
<script>


import listHelper from '@/helper/list-helper';
import categoryHelper from '@/helper/category-helper';
import { STORE_GETTER } from '../../../store/store';

export default {
	name: "SelectCategory",
	components: {},
	mixins: [],
	props:{
		categoryModel:Object,
		category:Object,
	},
	data() {
		return {
			//category: null,
			filterCategory: null,
			popoverCategory: false,
			showCategoryId: null,
		};
	},
	computed: {

		categoryPopover() {


			console.log('FP: CO2: popover: ', this.category);

			if (this.categoryTree == null){
				console.log('FP: CO2: popover: return 1 ');
				return ({ name: "Hittade inga kategorier", categoryList: [], parent: 0 });
			}
			
			if (this.category == null && this.categoryTree) { // FP-CT-K
				//return ({ name: "Kategorier", categoryList: this.categoryTree, parent: 0 });
				//return ({ name: "Kategorier", categoryList: this.categoryTree?.categoryList, parent: 0 }); // FP-CT
				console.log('FP: CO2: popover: return 2');
				return (this.categoryTree); // FP-CT
			}

			if (this.category && !this.category.categoryList) {

				//const category = categoryHelper.findNode(this.category.parent, { categoryId: -1, categoryList: this.categoryTree });

				const category = categoryHelper.findNode(this.category.parent, this.categoryTree); // FP-CT 
				console.log('FP: CO2: popover: return 3');
				return category;
			}

			console.log('FP: CO2: popover: return 4');
			return this.category

		},

		productCountCategory() { // TODO kolla om denna används

			if (this.category) {
				return "---";
			}



			return "--";
		},

		isFilterCategoryEmpty() {
			return this.filterCategory == null || this.filterCategory == ""
		},

		categoryList() {

			//onst baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryList) {
				return this.categoryModel.categoryList
			}

			return null;
		},

		filteredCategoryList() {
			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			// FP: 2026 söker bara i den aktuela listan 
			if (this.categoryModel && this.categoryModel.categoryList) {

				const categoryList = this.categoryModel.categoryList?.filter(category => this.enabledCategoryIdMap?.get(category?.categoryId))

				const list = listHelper.filterList(categoryList, this.filterCategory);

				return list;
			}

			/*
			if (this.categoryModel && this.categoryModel.categoryList) {

				const list = listHelper.filterList(this.categoryModel.categoryList, this.filterCategory);

				return list;
			}*/

			return null;
		},

		categoryTree() {

			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryTree) {
				return this.categoryModel.categoryTree
			}

			return null;
		},

		categoryPath() {

			return categoryHelper.getCategoryPath(this.categoryTree, this.category);

			

		},
		enabledCategoryIdMap() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_RESULT]?.categoryIdMap
		},
		enabledCategoryList(){
			return this.categoryPopover?.categoryList?.filter(category => this.enabledCategoryIdMap?.get(category?.categoryId) || this.debug)
			
		},
		highlight() {
			const searchProductConfig = this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
			
			if (!searchProductConfig) {
				return false;
			}

			return searchProductConfig.category;
		},
		title() {
			if (!this.disabled) {
				return "Välj kategorier"
			} else {
				return "Välj först 'Alla produkter' du visar bara ett urval av produkter. ";
			}
		},
		disabled() {
			return !this.$store.getters[STORE_GETTER.PRODUCT_SEARCH_ENABLED];
		}


	},
	watch: {
		
		popoverCategory: function (popoverCategory) { // TODO kolla om denna behövs

			if (popoverCategory){
				this.$emit("selectPopoverOpen", "popoverCategory");
			}
			
		},

		
	},
	methods: {

		togglePopover(){
			if (this.disabled) {
				alert(this.title)

				return;
			}

			this.popoverCategory = !this.popoverCategory
		},
		closePopover() {
			this.popoverCategory = false
		},
		setCategory(category){
			this.$emit("categorySelected", category)
		},
		setupScroll() {

			if (this.category && this.$refs.categoryListRef) {

				//alert("cid:" + this.category.categoryId)

				const categoryDiv = this.$refs.categoryListRef.find(categoryDiv => categoryDiv.id == "category-" + this.category.categoryId)

				if (categoryDiv) {
					categoryDiv.scrollIntoView({ block: "nearest", inline: "nearest" })
				}

			} else if (this.$refs.categoryListRef) {
				this.$refs.categoryListRef.scrollTop = 0;
			}
		},
		selectCategory(categoryId) {
			/*const category = this.categoryList.find(category => category.categoryId == categoryId);

			if (category) {
				alert(category.name);
			}

			alert(categoryId);*/

			if (categoryId == 3) { // FP: detta är om det blir träff på en topp-node, de ligger ju alla i /Boove (id: 3)
				//alert("categoryId:3 kolla upp")
				this.setCategory(null);
				return;
			}

			const category = categoryHelper.findInCategoryTree(categoryId, this.categoryTree);
			//const category = this.findNode2(categoryId);

			if (category) {
				this.setCategory(category);
			}

			console.log('FP: category:', category);

		},

	
		categoryPathLabel(categoryPath) { // loopar en lista av categorier? och appendar dess path 

			var label = "";

			var i = 0;

			if (categoryPath && categoryPath.length > 2){ // om längden är över 2 så visa inte namnet på root-noden. 
				i = 1
			}


			for (; i < categoryPath.length - 1; i++) { // loopa alla men ta inte med den sista
				label = label + categoryPath[i].name;

				if (i < categoryPath.length - 2) {
					label = label + "/";
				}
			}



			return label;
		},

		isCategoryEnabledLabel(category) {

			//console.log('FP: enabledCategoryIdMap: ', this.enabledCategoryIdMap.get(category.categoryId));

			if (!this.debug){
				return "";
			}

			if (this.enabledCategoryIdMap?.get(category.categoryId)) {
				return " ON";
			} else {
				return " --";
			}



		},




	},
	created() {

	},
	updated(){
		this.setupScroll()
	}
};
</script>

<style scoped>


div.filter-wrapper.not-selected  {
	background: var(--grey-2);
}



div.filter-wrapper.selected div.filter-button {
	background: var(--bg-message);
	color: white;
}



div.categoryArrow img.link {
	opacity: 0.2;
}

div.categoryArrow:hover img.link {
	opacity: 0.9;
}

div.breadcrumbs div.childCategoryList div.badge {
	background: var(--grey-4);
	color: var(--grey-dark-2);
}

.font-normal {
	font-size: var(--filter-wrapper-font-normal, 1rem);
}

.font-small {
	font-size: var(--filter-wrapper-font-small, 0.85rem);
}

div.filter-wrapper div.filter-button div.filter-button-label {
	margin-top: 2px;
}


@media (max-width:768px) {

	div.filter-wrapper {
		width: 100%;
		margin-bottom: 5px;
	}

	div.filter-wrapper div.filter-button {
		display: flex;
		flex-direction: row;

	}

	div.filter-wrapper div.filter-button div.filter-button-label {
		padding-left: 5px;
		margin-top: 0px;
	}
}

div.link.categoryLabel{
	padding:5px;
}

@media (max-width:768px) {
	div.link.categoryLabel {
			padding: 10px;
		}
}

b.disabled {
	color: var(--font-color-grey-light);
}

div.disabled {
	color: var(--font-color-grey-light);
}

</style>